/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/



// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import { Grid } from "@mui/material";


// Soft UI Dashboard PRO React example components

// SmartHome dashboard components

// Data


//Backend access
import { useQuery } from '@tanstack/react-query';
import { getCameraFeed, loadToken } from 'api/bks';
import PropTypes from "prop-types";



import { useAuth0 } from "@auth0/auth0-react";

// Images



function CameraLatest({ uuid }) {

  loadToken(useAuth0());

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ['getCameraFeed', uuid],
    queryFn: async () => {
      const data = await getCameraFeed(uuid);
      return data;
    },
    staleTime: Infinity,
  });

  if (isLoading) {
    return "Loading...";
  }

  if (error) {
    return "Error! " + error.message;
  }

  const blob = new Blob([data]);
  const url = URL.createObjectURL(blob);


  return (
    <SoftBox
    component="img"
    src={url}
    position="relative"
    maxWidth="100%"
    height="100%"
    borderRadius="lg"
  />

  );
}



// Typechecking props for the CameraLatest
CameraLatest.propTypes = {
  uuid: PropTypes.string
};


export default CameraLatest;
